import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Terapist müsaitliklerini getir
export const getMyAvailabilities = createAsyncThunk(
  "availabilities/getMyAvailabilities",
  async (therapistId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      
      const response = await axios.get(
        `${API_URL}/availabilities/therapist/${therapistId}`, 
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Availability information not found"
      );
    }
  }
);

// Tek müsaitlik oluştur
export const createAvailability = createAsyncThunk(
  "availabilities/createAvailability",
  async (availabilityData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      
      // therapistId'yi string olarak gönderdiğimizden emin olalım
      const requestData = {
        ...availabilityData,
        therapistId: String(availabilityData.therapistId)
      };
      
      console.log("Sent data:", requestData);
      
      const response = await axios.post(
        `${API_URL}/availabilities`, 
        requestData,
        config
      );
      
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Availability could not be created"
      );
    }
  }
);

// Müsaitlik yeniden aç (refund sonrası)
export const reopenAvailability = createAsyncThunk(
  "availabilities/reopenAvailability",
  async (availabilityId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(
        `${API_URL}/availabilities/${availabilityId}/reopen`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return { availabilityId, data: response.data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Availability could not be reopened"
      );
    }
  }
);

// Müsaitlik sil
export const deleteAvailability = createAsyncThunk(
  "availabilities/deleteAvailability",
  async (availabilityId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      
      const response = await axios.delete(
        `${API_URL}/availabilities/${availabilityId}`, 
        config
      );
      
      return { availabilityId, message: response.data.message };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Availability not deleted"
      );
    }
  }
);

const availabilitySlice = createSlice({
  name: "availability", 
  initialState: {
    availabilities: [],
    loading: false,
    error: null,
    success: false,
    message: ""
  },
  reducers: {
    clearAvailabilityError: (state) => {
      state.error = null;
    },
    clearAvailabilitySuccess: (state) => {
      state.success = false;
      state.message = "";
    }
  },
  
  extraReducers: (builder) => {
    // Müsaitlik getirme
    builder.addCase(getMyAvailabilities.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getMyAvailabilities.fulfilled, (state, action) => {
      state.loading = false;
      state.availabilities = action.payload;
      state.error = null;
    });
    builder.addCase(getMyAvailabilities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error.message;
    });
    
    // Tek müsaitlik oluşturma
    builder.addCase(createAvailability.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createAvailability.fulfilled, (state, action) => {
      state.loading = false;
      state.availabilities.push(action.payload);
      state.success = true;
      state.message = "Availability created successfully";
      state.error = null;
    });
    builder.addCase(createAvailability.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error.message;
    });
    
    // Müsaitlik yeniden açma
    builder.addCase(reopenAvailability.fulfilled, (state, action) => {
      const slot = state.availabilities.find(
        (a) => a._id === action.payload.availabilityId
      );
      if (slot) slot.isBooked = false;
    });

    // Müsaitlik silme
    builder.addCase(deleteAvailability.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteAvailability.fulfilled, (state, action) => {
      state.loading = false;
      state.availabilities = state.availabilities.filter(
        (item) => item._id !== action.payload.availabilityId
      );
      state.success = true;
      state.message = action.payload.message || "Availability deleted successfully";
      state.error = null;
    });
    builder.addCase(deleteAvailability.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error.message;
    })
  },
});

export const { clearAvailabilityError, clearAvailabilitySuccess } = availabilitySlice.actions;
export default availabilitySlice.reducer;